import { FaTruck } from "react-icons/fa";

export const SUPER_ADMIN_LOGISTICS_GROUP = {
  id: "logistics",
  heading: "Logistics",
  icon: FaTruck,
  items: [
    {
      id: "sa_business_relocation_rfqs",
      label: "Business Relocation RFQs",
      to: "/super-admin/logistics/business-relocation-rfqs",
      icon: FaTruck,
      end: true,
      activePathPrefix: "/super-admin/logistics/business-relocation-rfqs",
    },
    {
      id: "sa_exhibition_logistics_rfqs",
      label: "Exhibition Logistics RFQs",
      to: "/super-admin/logistics/exhibition-logistics-rfqs",
      icon: FaTruck,
      end: true,
      activePathPrefix: "/super-admin/logistics/exhibition-logistics-rfqs",
    },
  ],
};
